<template>
  <div v-if="task" class="task-modal-backdrop" @click.self="cancel">
    <section class="task-modal compact" role="dialog" aria-modal="true" aria-labelledby="return-sales-title">
      <header><div><span class="modal-eyebrow danger">RETURN TO SALES</span><h2 id="return-sales-title">确认退回销售？</h2></div><button type="button" class="modal-close" aria-label="关闭" @click="cancel"><X :size="18" /></button></header>
      <p class="return-help">订单 {{ task.orderNo }} 将回到销售侧待处理流程。请说明问题，方便销售快速跟进。</p>
      <label class="return-reason"><span>退回原因</span><textarea v-model.trim="reason" maxlength="200" rows="5" placeholder="例如：客户信息需补充、尺寸需确认、素材清晰度不足…"></textarea><small>{{ reason.length }}/200</small></label>
      <footer><button type="button" class="filter-reset" :disabled="submitting" @click="cancel">暂不退回</button><button type="button" class="danger-submit" :disabled="submitting || !reason" @click="$emit('confirm', { task, reason })">{{ submitting ? '提交中…' : '确认退回' }}</button></footer>
    </section>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { X } from '@lucide/vue';
const props = defineProps({ task: { type: Object, default: null }, submitting: Boolean });
const emit = defineEmits(['close', 'confirm']);
const reason = ref('');
watch(() => props.task, () => { reason.value = ''; });
function cancel() { if (!props.submitting) emit('close'); }
</script>
